export const GET_MERCHANTS = "GET_MERCHANTS"
export const GET_MERCHANTS_SUCCESS = "GET_MERCHANTS_SUCCESS"
export const GET_MERCHANTS_FAIL = "GET_MERCHANTS_FAIL"
export const CLEAR_MERCHANTS = "CLEAR_MERCHANTS"

// Add New Merchant
export const ADD_NEW_MERCHANT = "ADD_NEW_MERCHANT"
export const ADD_NEW_MERCHANT_SUCCESS = "ADD_NEW_MERCHANT_SUCCESS"
export const ADD_NEW_MERCHANT_FAIL = "ADD_NEW_MERCHANT_FAIL"

//Get Merchant Detail
export const GET_MERCHANT_DETAIL = "GET_MERCHANT_DETAIL"
export const GET_MERCHANT_DETAIL_SUCCESS = "GET_MERCHANT_DETAIL_SUCCESS"
export const GET_MERCHANT_DETAIL_FAIL = "GET_MERCHANT_DETAIL_FAIL"
export const CLEAR_MERCHANT_DETAIL = "CLEAR_MERCHANT_DETAIL"

// Merchant Communications
export const GET_MERCHANT_COMMUNICATIONS = "GET_MERCHANT_COMMUNICATIONS"
export const GET_MERCHANT_COMMUNICATIONS_SUCCESS = "GET_MERCHANT_COMMUNICATIONS_SUCCESS"
export const GET_MERCHANT_COMMUNICATIONS_FAIL = "GET_MERCHANT_COMMUNICATIONS_FAIL"
export const CLEAR_MERCHANT_COMMUNICATIONS = "CLEAR_MERCHANT_COMMUNICATIONS"

// Add/Update Merchant Communication
export const MANAGE_MERCHANT_COMMUNICATION = "MANAGE_MERCHANT_COMMUNICATION"
export const MANAGE_MERCHANT_COMMUNICATION_SUCCESS = "MANAGE_MERCHANT_COMMUNICATION_SUCCESS"
export const MANAGE_MERCHANT_COMMUNICATION_FAIL = "MANAGE_MERCHANT_COMMUNICATION_FAIL"

// Merchant Contacts
export const GET_MERCHANT_CONTACTS = "GET_MERCHANT_CONTACTS"
export const GET_MERCHANT_CONTACTS_SUCCESS = "GET_MERCHANT_CONTACTS_SUCCESS"
export const GET_MERCHANT_CONTACTS_FAIL = "GET_MERCHANT_CONTACTS_FAIL"
export const CLEAR_MERCHANT_CONTACTS = "CLEAR_MERCHANT_CONTACTS"

// Manage Merchant Contact
export const MANAGE_MERCHANT_CONTACT = "MANAGE_MERCHANT_CONTACT"
export const MANAGE_MERCHANT_CONTACT_SUCCESS = "MANAGE_MERCHANT_CONTACT_SUCCESS"
export const MANAGE_MERCHANT_CONTACT_FAIL = "MANAGE_MERCHANT_CONTACT_FAIL"

// Merchant Contact Communications
export const GET_MERCHANT_CONTACT_COMMUNICATIONS = "GET_MERCHANT_CONTACT_COMMUNICATIONS"
export const GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS = "GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS"
export const GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL = "GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL"

// Manage Merchant Contact Communication
export const MANAGE_MERCHANT_CONTACT_COMMUNICATION = "MANAGE_MERCHANT_CONTACT_COMMUNICATION"
export const MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS = "MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS"
export const MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL = "MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL"

// Merchant Banking (Following Communication Pattern)
export const GET_MERCHANT_BANKING_DETAIL = "GET_MERCHANT_BANKING_DETAIL"
export const GET_MERCHANT_BANKING_DETAIL_SUCCESS = "GET_MERCHANT_BANKING_DETAIL_SUCCESS"
export const GET_MERCHANT_BANKING_DETAIL_FAIL = "GET_MERCHANT_BANKING_DETAIL_FAIL"
export const CLEAR_MERCHANT_BANKING_DETAIL = "CLEAR_MERCHANT_BANKING_DETAIL"

// Add New Merchant Banking
export const ADD_NEW_MERCHANT_BANKING = "ADD_NEW_MERCHANT_BANKING"
export const ADD_NEW_MERCHANT_BANKING_SUCCESS = "ADD_NEW_MERCHANT_BANKING_SUCCESS"
export const ADD_NEW_MERCHANT_BANKING_FAIL = "ADD_NEW_MERCHANT_BANKING_FAIL"

// Manage Merchant Banking (activate/deactivate)
export const MANAGE_MERCHANT_BANKING = "MANAGE_MERCHANT_BANKING"
export const MANAGE_MERCHANT_BANKING_SUCCESS = "MANAGE_MERCHANT_BANKING_SUCCESS"
export const MANAGE_MERCHANT_BANKING_FAIL = "MANAGE_MERCHANT_BANKING_FAIL"

// Toggle Merchant Banking Default (Set/Unset Default)
export const TOGGLE_MERCHANT_BANKING_DEFAULT = "TOGGLE_MERCHANT_BANKING_DEFAULT"
export const TOGGLE_MERCHANT_BANKING_DEFAULT_SUCCESS = "TOGGLE_MERCHANT_BANKING_DEFAULT_SUCCESS"
export const TOGGLE_MERCHANT_BANKING_DEFAULT_FAIL = "TOGGLE_MERCHANT_BANKING_DEFAULT_FAIL"

// Check Merchant Banking Status
export const CHECK_MERCHANT_BANKING_STATUS = "CHECK_MERCHANT_BANKING_STATUS"
export const CHECK_MERCHANT_BANKING_STATUS_SUCCESS = "CHECK_MERCHANT_BANKING_STATUS_SUCCESS"
export const CHECK_MERCHANT_BANKING_STATUS_FAIL = "CHECK_MERCHANT_BANKING_STATUS_FAIL"

// Merchant Attributes Action Types
export const GET_MERCHANT_ATTRIBUTES = "GET_MERCHANT_ATTRIBUTES"
export const GET_MERCHANT_ATTRIBUTES_SUCCESS = "GET_MERCHANT_ATTRIBUTES_SUCCESS"
export const GET_MERCHANT_ATTRIBUTES_FAIL = "GET_MERCHANT_ATTRIBUTES_FAIL"
export const CLEAR_MERCHANT_ATTRIBUTES = "CLEAR_MERCHANT_ATTRIBUTES"

export const MANAGE_MERCHANT_ATTRIBUTE = "MANAGE_MERCHANT_ATTRIBUTE"
export const MANAGE_MERCHANT_ATTRIBUTE_SUCCESS = "MANAGE_MERCHANT_ATTRIBUTE_SUCCESS"
export const MANAGE_MERCHANT_ATTRIBUTE_FAIL = "MANAGE_MERCHANT_ATTRIBUTE_FAIL"

// Merchant Variables Action Types
export const GET_MERCHANT_VARIABLES = "GET_MERCHANT_VARIABLES"
export const GET_MERCHANT_VARIABLES_SUCCESS = "GET_MERCHANT_VARIABLES_SUCCESS"
export const GET_MERCHANT_VARIABLES_FAIL = "GET_MERCHANT_VARIABLES_FAIL"
export const CREATE_MERCHANT_VARIABLES = "CREATE_MERCHANT_VARIABLES"
export const CREATE_MERCHANT_VARIABLES_SUCCESS = "CREATE_MERCHANT_VARIABLES_SUCCESS"
export const CREATE_MERCHANT_VARIABLES_FAIL = "CREATE_MERCHANT_VARIABLES_FAIL"
export const UPDATE_MERCHANT_VARIABLES = "UPDATE_MERCHANT_VARIABLES"
export const UPDATE_MERCHANT_VARIABLES_SUCCESS = "UPDATE_MERCHANT_VARIABLES_SUCCESS"
export const UPDATE_MERCHANT_VARIABLES_FAIL = "UPDATE_MERCHANT_VARIABLES_FAIL"
export const CLEAR_MERCHANT_VARIABLES = "CLEAR_MERCHANT_VARIABLES"

// Reconciliation Frequencies Action Types
export const GET_RECONCILIATION_FREQUENCIES = "GET_RECONCILIATION_FREQUENCIES"
export const GET_RECONCILIATION_FREQUENCIES_SUCCESS = "GET_RECONCILIATION_FREQUENCIES_SUCCESS"
export const GET_RECONCILIATION_FREQUENCIES_FAIL = "GET_RECONCILIATION_FREQUENCIES_FAIL"
export const CLEAR_RECONCILIATION_FREQUENCIES = "CLEAR_RECONCILIATION_FREQUENCIES"

// Local state management for attribute form
export const ADD_ATTRIBUTE_TO_FORM = "ADD_ATTRIBUTE_TO_FORM"
export const UPDATE_ATTRIBUTE_IN_FORM = "UPDATE_ATTRIBUTE_IN_FORM"
export const REMOVE_ATTRIBUTE_FROM_FORM = "REMOVE_ATTRIBUTE_FROM_FORM"
export const CLEAR_ATTRIBUTE_FORM = "CLEAR_ATTRIBUTE_FORM"

// Contact Creation Phase State Management
export const SET_CONTACT_CREATION_STATE = "SET_CONTACT_CREATION_STATE"
export const CLEAR_CONTACT_CREATION_STATE = "CLEAR_CONTACT_CREATION_STATE"

// Delete Merchant
export const DELETE_MERCHANT = "DELETE_MERCHANT"
export const DELETE_MERCHANT_SUCCESS = "DELETE_MERCHANT_SUCCESS"
export const DELETE_MERCHANT_FAIL = "DELETE_MERCHANT_FAIL"

// Merchant Images Action Types
export const GET_MERCHANT_IMAGES = "GET_MERCHANT_IMAGES"
export const GET_MERCHANT_IMAGES_SUCCESS = "GET_MERCHANT_IMAGES_SUCCESS"
export const GET_MERCHANT_IMAGES_FAIL = "GET_MERCHANT_IMAGES_FAIL"
export const CLEAR_MERCHANT_IMAGES = "CLEAR_MERCHANT_IMAGES"

export const MANAGE_MERCHANT_IMAGE = "MANAGE_MERCHANT_IMAGE"
export const MANAGE_MERCHANT_IMAGE_SUCCESS = "MANAGE_MERCHANT_IMAGE_SUCCESS"
export const MANAGE_MERCHANT_IMAGE_FAIL = "MANAGE_MERCHANT_IMAGE_FAIL"

export const REORDER_MERCHANT_IMAGES = "REORDER_MERCHANT_IMAGES"
export const REORDER_MERCHANT_IMAGES_SUCCESS = "REORDER_MERCHANT_IMAGES_SUCCESS"
export const REORDER_MERCHANT_IMAGES_FAIL = "REORDER_MERCHANT_IMAGES_FAIL"
export const SET_LOCAL_IMAGES_ORDER = "SET_LOCAL_IMAGES_ORDER"
export const RESET_LOCAL_IMAGES_ORDER = "RESET_LOCAL_IMAGES_ORDER"

// Merchant Timings
export const GET_MERCHANT_TIMINGS = "GET_MERCHANT_TIMINGS"
export const GET_MERCHANT_TIMINGS_SUCCESS = "GET_MERCHANT_TIMINGS_SUCCESS"
export const GET_MERCHANT_TIMINGS_FAIL = "GET_MERCHANT_TIMINGS_FAIL"
export const CLEAR_MERCHANT_TIMINGS = "CLEAR_MERCHANT_TIMINGS"

// Manage Merchant Timing
export const MANAGE_MERCHANT_TIMING = "MANAGE_MERCHANT_TIMING"
export const MANAGE_MERCHANT_TIMING_SUCCESS = "MANAGE_MERCHANT_TIMING_SUCCESS"
export const MANAGE_MERCHANT_TIMING_FAIL = "MANAGE_MERCHANT_TIMING_FAIL"
export const ADD_TIMING_TO_FORM = "ADD_TIMING_TO_FORM"
export const UPDATE_TIMING_IN_FORM = "UPDATE_TIMING_IN_FORM"
export const REMOVE_TIMING_FROM_FORM = "REMOVE_TIMING_FROM_FORM"
export const CLEAR_TIMING_FORM = "CLEAR_TIMING_FORM"
export const CLEAR_TIMING_CREATION_SUCCESS = "CLEAR_TIMING_CREATION_SUCCESS"
export const CLEAR_ATTRIBUTE_CREATION_SUCCESS = "CLEAR_ATTRIBUTE_CREATION_SUCCESS"

// Merchant Tags Action Types
export const GET_MERCHANT_TAGS = "GET_MERCHANT_TAGS"
export const GET_MERCHANT_TAGS_SUCCESS = "GET_MERCHANT_TAGS_SUCCESS"
export const GET_MERCHANT_TAGS_FAIL = "GET_MERCHANT_TAGS_FAIL"
export const CLEAR_MERCHANT_TAGS = "CLEAR_MERCHANT_TAGS"

export const MANAGE_MERCHANT_TAG = "MANAGE_MERCHANT_TAG"
export const MANAGE_MERCHANT_TAG_SUCCESS = "MANAGE_MERCHANT_TAG_SUCCESS"
export const MANAGE_MERCHANT_TAG_FAIL = "MANAGE_MERCHANT_TAG_FAIL"

// Tag Definitions Action Types
export const GET_TAG_DEFINITIONS = "GET_TAG_DEFINITIONS"
export const GET_TAG_DEFINITIONS_SUCCESS = "GET_TAG_DEFINITIONS_SUCCESS"
export const GET_TAG_DEFINITIONS_FAIL = "GET_TAG_DEFINITIONS_FAIL"
export const CLEAR_TAG_DEFINITIONS = "CLEAR_TAG_DEFINITIONS"

// Merchant PINs Action Types
export const GET_MERCHANT_PINS = "GET_MERCHANT_PINS"
export const GET_MERCHANT_PINS_SUCCESS = "GET_MERCHANT_PINS_SUCCESS"
export const GET_MERCHANT_PINS_FAIL = "GET_MERCHANT_PINS_FAIL"
export const CLEAR_MERCHANT_PINS = "CLEAR_MERCHANT_PINS"

export const SHOW_MERCHANT_PINS = "SHOW_MERCHANT_PINS"
export const SHOW_MERCHANT_PINS_SUCCESS = "SHOW_MERCHANT_PINS_SUCCESS"
export const SHOW_MERCHANT_PINS_FAIL = "SHOW_MERCHANT_PINS_FAIL"

export const UPDATE_MERCHANT_PINS = "UPDATE_MERCHANT_PINS"
export const UPDATE_MERCHANT_PINS_SUCCESS = "UPDATE_MERCHANT_PINS_SUCCESS"
export const UPDATE_MERCHANT_PINS_FAIL = "UPDATE_MERCHANT_PINS_FAIL"
